import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const changePassword = createAsyncThunk('changePassword', async (data) => {
    try {
        const res = await axios({

            method: "PUT",
            url: process.env.REACT_APP_API_URL + 'change_password',
            data: {
                "password": data?.old_password,
                "newPassword": data?.confirm_password,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('user_token'),
            }
        })
        return res
    } catch (error) {
        return error.response
    }
})